import React, { useEffect, useState } from "react";
import TableLoader from "../../../../common/tableLoader";
import { useSelector } from "react-redux";
import apiCall from "../../../../../apicall";
import Toast from "../../../../common/toast";
import Spinner from "../../../../common/spinner";

const EmpHourlyRateList = ({
    empDetailId,
    handleHourlyListRes,
}) => {
    const { role_type, TOKEN } = useSelector((state) => state.menu);
    const [empJobsInfo, setEmpJobsInfo] = useState({});
    const [jobsLoader, setJobsLoader] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [rowJobsPerPage, setJobsRowPerPage] = useState(10);
    const [paginationJobsData, setPaginationJobsData] = useState({
        totalElements: 0,
        totalPages: 0
    });
    const [isLoading, setIsLoading] = useState(false);
    const [formValues, setFormValues] = useState({});
    const displayEmpLocationErrMsg = (errMsg) => {
        setErrSuccessMsg({
            message: errMsg,
            status: false,
        });
        setEmpJobsInfo({});
    };
    const [formErrors, setFormErrors] = useState({});
    const [errSuccessMesg, setErrSuccessMsg] = useState({
        message: "",
        status: "error",
    });

    const displayErrMsg = (errMsg) => {
        setErrSuccessMsg({
            message: errMsg,
            status: false,
        });
        setIsLoading(false);
    };
    const handleInputChange = (e, index) => {
        const value = e.target.value;

        // Allow only numbers and check if the value is less than or equal to 100
        if (/^\d*$/.test(value) || value === "") {
            setFormValues((prevValues) => ({
                ...prevValues,
                [index]: value,
            }));
        }
        setFormErrors((prevErrors) => ({
            ...prevErrors,
            [index]: "",
        }));
    };
    //   const validateForm = () => {
    //     const errors = {};

    //     // Validate fields common to both roles
    //     if (!formValues.hourlyRate || formValues.hourlyRate.trim() === "") {
    //       errors.hourlyRate = "Hourly Rate is required.";
    //     }

    //     // Log errors for debugging
    //     console.log("Validation Errors:", errors);

    //     setFormErrors(errors);
    //     return Object.keys(errors).length === 0; // Return true if no errors, false if there are errors
    //   };
    const validateForm = () => {
        const errors = {};
        console.log("Form Values before validation:", formValues);

        // Loop through formValues to validate each hourlyRate separately
        Object.keys(formValues).forEach((index) => {
            // if (!formValues[index] || formValues[index].toString().trim() === "") {
            if (formValues[index] !== "" && !formValues[index]) {
                errors[index] = "Hourly Rate is required.";
            }
        });

        // Log errors for debugging
        console.log("Validation Errors:", errors);

        setFormErrors(errors);
        return Object.keys(errors).length === 0; // Return true if no errors, false otherwise
    };

    const handleHourlyRateSubmit = async (event, index) => {
        event.preventDefault();

        if (validateForm()) {
            setIsLoading(true);
            try {
                const formattedData = empJobsInfo.map((job, index) => ({
                    ...job,
                    hourlyRate: formValues[index] !== undefined 
                        ? parseFloat((parseFloat(formValues[index]) * 100).toFixed(1))  // Ensure correct format
                        : job.hourlyRate,
                })).filter(job => job.hourlyRate !== undefined && job.HourlyRate !== null);
    
                console.log("Updated Payload:", formattedData);

                if (formattedData.length === 0) {
                    console.log("No valid hourlyRate data to update.");
                    setIsLoading(false);
                    return;
                }
                const hourlyRateUpdateResponse = await apiCall(`openstaff/institutions/${empDetailId}/updateJobTypes`, "POST", formattedData, TOKEN);
                console.log("hourlyRateUpdateResponse", hourlyRateUpdateResponse)
                if (hourlyRateUpdateResponse?.status === 200) {
                  setErrSuccessMsg({
                    message: "Hourly Rate updated successfully!",
                    status: true,
                  });
                  setIsLoading(false);
                } else if (hourlyRateUpdateResponse?.response?.status == 401) {
                  setErrSuccessMsg({
                    message: "Your session has been expired!!",
                    status: false,
                  });
                  setIsLoading(false);
                } else {
                  setErrSuccessMsg({
                    message: hourlyRateUpdateResponse?.response?.data?.message,
                    status: false,
                  });
                  setIsLoading(false);
                }
            } catch (err) {
                setErrSuccessMsg({
                    message: "Something went wrong!",
                    status: false,
                });
            }
        } else {
            displayErrMsg("Check the form validation!");
        }
    };

    const getJobsData = async () => {
        try {
            setJobsLoader(true);
            const empJobsResponse = await apiCall(`openstaff/institutions/${empDetailId}/allJobTypes`, "GET", null, TOKEN);
            console.log("empJobsResponse---", empJobsResponse);

            if (empJobsResponse?.data?.length > 0) {
                setEmpJobsInfo(empJobsResponse.data);
                handleHourlyListRes(empJobsResponse.data, false)
            } else if (empJobsResponse?.data?.length == 0) {
                setEmpJobsInfo({});
                handleHourlyListRes({}, false)
            } else if (empJobsResponse?.response?.status == 401) {
                displayEmpLocationErrMsg("Your session has been expired!!");
                handleHourlyListRes({}, false)
            } else {
                displayEmpLocationErrMsg("Something went wrong!");
                handleHourlyListRes({}, false)
            }
        } catch (err) {
            displayEmpLocationErrMsg("Something went wrong!");
            handleHourlyListRes({}, false)
        } finally {
            setJobsLoader(false);
        }
    };


    useEffect(() => {
        if (role_type.includes("ROLE_OPENSTAFF_ADMIN") || role_type.includes("ROLE_OPENSTAFF_FINANCIAL_ADMIN")) {
            getJobsData();
        }
    }, [currentPage, rowJobsPerPage]);

    return (
        <>
            <div className="row site-bg-gray" style={{ padding: "5px 15px 10px 15px" }}>
                {/* <ul> */}
                    {!jobsLoader ? (
                        empJobsInfo?.length > 0 ? (
                            empJobsInfo?.map((item, index) => {
                                if (!item?.active) return null;
                                return (
                                    <div className="col-lg-4 col-md-12" key={index}>
                                        {/* <div className="twm-candidates-list-style1"> */}
                                        <div className="twm-jobs-grid-style1" style={{ marginTop: "15px", marginBottom: "15px" }}>
                                            {/* <div className="twm-media">
                                                
                                            </div> */}
                                            <div style={{ paddingTop: "0px" }} className="twm-mid-content"
                                            ><h4>{item?.typeName}</h4>
                                                <form id="change_hourly_rate">
                                                    <div className="row">
                                                        <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12">
                                                            <div className="form-group mb-2">
                                                                <div className="ls-inputicon-box">
                                                                    <input
                                                                        className="form-control"
                                                                        name={`hourlyRate-${index}`}
                                                                        type="text"
                                                                        placeholder="Hourly Rate"
                                                                        value={formValues[index] !== undefined ? formValues[index] : (item?.hourlyRate ? item.hourlyRate / 100 : "") || ""}
                                                                        onChange={(e) => handleInputChange(e, index)}
                                                                    />
                                                                </div>
                                                                {formErrors[index] && (
                                                                    <div className="error-message">
                                                                        {formErrors[index]}
                                                                    </div>
                                                                )}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </form>
                                            </div>
                                        </div>
                                    </div>
                                )
                            })
                        ) : (
                            "No results found."
                        )
                    ) : (
                        <TableLoader />
                    )}
                {/* </ul> */}
                <div className="col-xl-12 col-lg-12 col-md-6 col-sm-6">
                    <div>
                        <button
                            type="submit"
                            className="site-button"
                            onClick={(e) => handleHourlyRateSubmit(e)}
                        >
                            {isLoading ? <Spinner /> : "Save"}
                        </button>
                    </div>
                </div>
            </div>
            {errSuccessMesg?.message != "" ? <Toast message={errSuccessMesg} /> : ""}
        </>
    );
};

export default EmpHourlyRateList;
